import type { ReactNode } from 'react'

interface DialogHintProps {
  children: ReactNode
}

export default function DialogHint({ children }: DialogHintProps) {
  return <span className="sg-dialog__hint">{children}</span>
}

export function DialogLink({ children, onClick }: { children: ReactNode; onClick?: () => void }) {
  return <span className="sg-dialog__link" onClick={onClick}>{children}</span>
}
